import { axiosInstance } from './axiosInstance';
import axios from 'axios';

export const sendEmail = async (data) => {
    try {
        //const response = await axiosInstance.post('/api/v1/adminpanel/send-mail', data);
        //return response;
        let data = {
            message: "<h2>Hello 👋</h2><p>This is a <strong>test</strong> email</p>",
            subject: "Test Email",
            email: "mdaramari@gmail.com",
            bcc: ["divyesh.trambadia@gmail.com"]
        };
        let config = {
            method: 'post',
            url: `${process.env.REACT_APP_BACKEND_V1_URL}/api/v1/adminpanel/send-mail`,
            headers: {
                'db': 'tdr',
                'Content-Type': 'application/json',
                'Cookie': 'token=...'
            },
            data: data
        };

        axios.request(config)
            .then(response => console.log(response.data))
            .catch(error => console.log(error));
    } catch (error) {
        throw error.response || error;
    }
}

export const list = async (db) => {
    try {
        const response = await axiosInstance.get('/api/v1/adminpanel/company/list');
        return response;
    } catch (error) {
        throw error.response || error;
    }
};
export const sendEmailNotificationByCId = async (cID) => {
    try {
        const response = await axiosInstance.get(`/api/v1/adminpanel/company/email-notification/${cID}`);
        return response;
    } catch (error) {
        throw error.response || error;
    }
};

export const setEmailNotificationData = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/v1/adminpanel/company/update-data-cid/${data.cID}`, { "sendEmailNotification": data.sendEmailNotification });
        return response;
    } catch (error) {
        throw error.response || error;
    }
};

export const setS3Bucket = async (clientID, data) => {
    try {
        const response = await axiosInstance.post(`/api/v1/adminpanel/company/updatedata/${clientID}`, data);
        return response;
    } catch (error) {
        return error;
    }
};

export const updateCompanyData = async (data) => {
    try {

        const response = await axiosInstance.post(`/api/v1/adminpanel/company/update-data/${data._id}`, data);
        return response;
    } catch (error) {
        throw error.response || error;
    }
};
export const getBadgesByCID = async (id) => {
    try {
        const response = await axiosInstance.get(`/api/v1/adminpanel/company/badge/${id}`);
        return response;
    } catch (error) {
        return error
    }
};
export const setCallBackURL = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/v1/adminpanel/company/set-callback`, data);
        return response;
    } catch (error) {
        return error
    }
};

export const getUserByCID = async (id) => {
    try {
        const response = await axiosInstance.get(`/api/v1/adminpanel/company/user/${id}`);
        return response;
    } catch (error) {
        throw error.response || error;
    }
};
export const getCompanyDataByID = async (id) => {
    try {
        const response = await axiosInstance.get(`/api/v1/adminpanel/company/details/${id}`);
        return response;
    } catch (error) {
        throw error.response || error;
    }
};
export const getUserProfileByCID = async (id) => {
    try {
        const response = await axiosInstance.get(`/api/v1/adminpanel/company/user-profile-status/${id}`);
        return response;
    } catch (error) {
        return error;
    }
};

export const setActiveInActive = async (id) => {
    try {
        const response = await axiosInstance.get(`/api/v1/adminpanel/company/set-active-inactive/${id}`);
        return response;
    } catch (error) {
        throw error.response || error;
    }
};
export const deleteCompanyByID = async (id) => {
    try {
        const response = await axiosInstance.delete(`/api/v1/adminpanel/company/${id}`);
        return response;
    } catch (error) {
        throw error.response || error;
    }
};
export const companyDataByID = async (id) => {
    try {
        const response = await axiosInstance.get(`/api/v1/adminpanel/company/data/${id}`);
        return response;
    } catch (error) {
        throw error.response || error;
    }
};

export const badgeDataByID = async (cID) => {
    try {
        const response = await axiosInstance.get(`/api/v1/adminpanel/company/badges/${cID}`);
        return response;
    }
    catch (error) {
        throw error.response || error;
    }
};
export const deleteBadgeByCId = async (data) => {

    try {
        const response = await axiosInstance.post(`/api/v1/adminpanel/company/delete-badge/`, data);
        return response;
    } catch (error) {
        throw error.response || error;
    }
};

export const fetchBadgeByCIdandMain = async (id, main) => {
    try {
        const response = await axiosInstance.get(`/api/v1/adminpanel/company/badge/${id}/${main}`);
        // const response = await axiosInstance.get(`/api/v1/adminpanel/company/badge/${id}`);
        return response;
    } catch (error) {
        throw error.response || error;
    }
};


export const AddBadgeDetails = async (id, data) => {
    try {
        const response = await axiosInstance.post(`/api/v1/adminpanel/badge/add/${id}`, data);
        return response;
    } catch (error) {
        return error;
    }
};

export const editBadgeDetails = async (id, data) => {
    try {
        const response = await axiosInstance.post(`/api/v1/adminpanel/badge/edit/${id}`, data);
        return response;
    } catch (error) {
        return error
    }
};


export const userlistwithcompanydetails = async () => {
    try {
        const response = await axiosInstance.get(`/api/v1/adminpanel/company/userlist-with-company-details`);
        return response;
    } catch (error) {
        throw error.response || error;
    }
};